import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'submit', 'hidden'];
  static values = { expected: String };

  connect() {
    this.check();
    this.modal = this.element.closest('.modal');
    if (this.modal) {
      this.boundReset = () => this.reset();
      this.modal.addEventListener('hidden.bs.modal', this.boundReset);
    }
  }

  disconnect() {
    if (this.modal && this.boundReset) {
      this.modal.removeEventListener('hidden.bs.modal', this.boundReset);
    }
  }

  check() {
    const typed = (this.inputTarget.value || '').trim().toLowerCase();
    const expected = (this.expectedValue || '').trim().toLowerCase();
    const matches = typed.length > 0 && typed === expected;

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !matches;
    }
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = matches ? this.inputTarget.value : '';
    }
  }

  reset() {
    this.inputTarget.value = '';
    this.check();
  }
}
